import type { Permission } from "@/models/Permission";

type HeldPermission = Pick<Permission, "permissionCodeName">;

/**
 * Whether the permissions a user holds pass a route's meta gate.
 *
 * main.ts answers both the navigation guard and $canNavigateTo from this, so a
 * link can never offer a destination the guard would refuse. Kept apart from
 * main.ts so the gate itself can be tested.
 */
export function routeMetaAllows(meta: any, held: HeldPermission[]): boolean {
    const holds = (code: string): boolean =>
        held.some((p) => p.permissionCodeName.toLowerCase() === code.toLowerCase());

    if (meta?.permission) return holds(meta.permission);
    if (meta?.anyPermission) return meta.anyPermission.some(holds);
    // Signed in and holding some permission, whichever it is. A user in no team
    // usually holds none -- though a user flagged remote is still granted
    // Other/Remote Worker at sign-in, whatever their teams.
    if (meta?.requiresAnyPermission) return held.length > 0;
    return true;
}

/**
 * The permission the /unauthorized page names, or undefined when the gate has
 * no single code to name -- requiresAnyPermission asks for any code at all.
 */
export function requiredPermissionLabel(meta: any): string | undefined {
    return meta?.permission ?? meta?.anyPermission?.join(" or ");
}
